export function isDxfFileName(value) {
    if (typeof value !== "string") {
        return false;
    }
    return value.toLowerCase().endsWith(".dxf");
}
//# sourceMappingURL=isDxfFileName.js.map